import type { ScheduleItem } from "src/types";

const searchFilter = (item: ScheduleItem, search: string) =>
  search.length === 0 ||
  item.name.toLowerCase().includes(search) ||
  item.description?.toLowerCase().includes(search) ||
  item.speakers
    .map((s) => `${s.first_name.toLowerCase()} ${s.last_name.toLowerCase}`)
    .join(",")
    .includes(search) ||
  (item.tags &&
    item.tags
      .map((tag) => tag.name.toLowerCase())
      .join(",")
      .includes(search));

const partFilter = (item: ScheduleItem, selectedParts: string[]) =>
  !selectedParts.length ||
  selectedParts.some((part) => {
    if (item.event_part.event_type_custom_text) {
      return item.event_part.event_type_custom_text === part;
    }
    return item.event_part.event_part_type === part;
  });

const tagFilter = (item: ScheduleItem, selectedTags: string[]) =>
  !selectedTags.length ||
  item.tags.some((tag) => selectedTags.includes(tag.name));

interface FilteredScheduleItemsArgs {
  items: ScheduleItem[];
  search?: string;
  selectedTags?: string[];
  selectedParts?: string[];
}

export default function getFilteredScheduleItems({
  items,
  search = "",
  selectedParts = [],
  selectedTags = [],
}: FilteredScheduleItemsArgs) {
  return items
    .filter((item) => partFilter(item, selectedParts))
    .filter((item) => tagFilter(item, selectedTags))
    .filter((item) => searchFilter(item, search.toLowerCase()));
}
